// This file was created based off of its sibling YamlItem to use skeletor's components (Text and Link so far)
// Remove this comment after the old version is deleted (once all agents are updated)

import React from 'react'
import { Agent } from '../..'
import { IntlFormatters, useIntl } from 'react-intl'
import { downloadConfig } from '../../download-agent-config'
import { SkeletorDownloadItem } from '../common/skeletor-download-item'

export interface SkeletorYamlItemProps {
  agent: Agent
  organizationID: string
  i18nDownloadMessageId: string
  i18nAdditionalMessageIds: string[]
  formValue?: any
  isDisabled?: boolean
}

export function SkeletorYamlItem({
  agent,
  organizationID,
  i18nDownloadMessageId,
  i18nAdditionalMessageIds,
  formValue,
  isDisabled = false
}: SkeletorYamlItemProps) {
  const { formatMessage: formatMessageForDownload } = useIntl()

  return (
    <>
      <SkeletorDownloadItem
        formatMessage={formatMessageForDownload}
        download={(formatMessage) =>
          downloadYaml(agent, organizationID, formatMessage, formValue)
        }
        i18nDownloadMessageId={i18nDownloadMessageId}
        i18nAdditionalMessageIds={i18nAdditionalMessageIds}
        isDisabled={isDisabled}
      />
    </>
  )
}

const downloadYaml = (
  agent: Agent,
  organizationID: string,
  formatMessage: IntlFormatters['formatMessage'],
  formValue: any
) =>
  downloadConfig({
    organizationID,
    agentParam: agent,
    body: {
      metadata: Object.keys(formValue).map((agentLabel) => ({
        agentLabel,
        value: formValue[agentLabel]
      }))
    },
    formatMessage
  })
